import { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Container, H2, Subtitle1, H4, Body1, Button, Share, CustomIcon } from '../../../cdl-react-components/components'
import SampleButton from '../../../Utilities/SampleButton'
import Link from '../../../Utilities/Link'
import { formatBytes } from '../../../cdl-react-components/utilities/files'
import { getArticleFeatureImage, formatResultsItemDate } from '../../../../utilities'

class ArticleMobile extends Component {

    renderArticleButton = (article, authenticated, user) => {
        if (!article.pdf)
            return null
        else if (new Date(article.publication_date) > new Date())
            return null
        else if (article['free_article'])
            // Free Article
            return (<Link className="btn btn--raised" href={this.props.link}>Free Article</Link>)
        else if (authenticated)
            // Logged in, Subscribed
            return (<Link className="btn btn--raised" href={this.props.link}>Read Article</Link>)
        else if (article.sample_article)
            // Sample Article
            return (<SampleButton href={this.props.sampleLink} type="Digest Article">Read Sample Article</SampleButton>)
        else if (user)
            // Logged in, Not subscribed
            return (<Link className="btn btn--raised" href="/subscribe">Subscribe</Link>)
        else
            // Not logged in
            return (
                // <Fragment>
                //     <Link className="btn" href="/subscribe">Subscribe</Link>
                    <Button raised secondary onClick={this.props.handleLogin}>Login to Read Article</Button>
                // </Fragment>
            )
    }

    renderArticleContents = article => {
        return (
            <div className="article__contents">
                <H4>Contents</H4>
                <table>
                    <tbody>
                        <tr>
                            <th>Article&nbsp;type:</th>
                            <td>{this.props.commaSeporate(article.article_type)}</td>
                        </tr>
                        {article.pdf && (
                            <Fragment>
                                <tr>
                                    <th>File&nbsp;size:</th>
                                    <td>{article.pdf_size_field ? formatBytes(article.pdf_size_field, 2) : null}</td>
                                </tr>
                                <tr>
                                    <th>Word&nbsp;count:</th>
                                    <td>{article.word_count}</td>
                                </tr>
                                <tr>
                                    <th>Table&nbsp;count:</th>
                                    <td>{article.table_count}</td>
                                </tr>
                                <tr>
                                    <th>Figure&nbsp;count:</th>
                                    <td>{article.figure_count}</td>
                                </tr>
                                <tr>
                                    <th></th>
                                    <td>
                                        <ul>
                                            {article.figure_types.map(x => (<li key={'article__contents__figure_type--' + x.id}><CustomIcon>check</CustomIcon>{x.name}</li>))}
                                        </ul>
                                    </td>
                                </tr>
                            </Fragment>
                        )}
                    </tbody>
                </table>
            </div>
        )
    }

    render() {
        const { article, authenticated, user } = this.props

        const authors = this.props.commaSeporateComponents(article.authors, 'authors')

        return (
            <div id="article--mobile">
                <div className="article__image" style={{ backgroundImage: `url(${getArticleFeatureImage(article)})`}} />
                <Container>
                    <H2>{article.title}</H2>
                    <Subtitle1>{article.subtitle}</Subtitle1>
                    <Body1>{authors}{authors.length > 0 && ' | '}{formatResultsItemDate(article)}</Body1>
                    <Body1 dangerouslySetInnerHTML={{ __html: article.synopsis }} />
                    <div className="flex flex--center">
                        {this.renderArticleButton(article, authenticated, user)}
                    </div>
                    <hr />
                    {this.renderArticleContents(article)}
                    <hr />
                    <div>
                        <table className="article__details-table">
                            <tbody>
                                <tr>
                                    <th>Play(s):</th>
                                    <td>{article.plays && article.plays.length ? this.props.commaSeporateComponents(article.plays, 'plays') : 'N/A'}</td>
                                </tr>
                                <tr>
                                    <th>Fluid(s):</th>
                                    <td>{article.fluids && article.fluids.length ? this.props.commaSeporateComponents(article.fluids, 'fluids') : 'N/A'}</td>
                                </tr>
                                <tr>
                                    <th>Area:</th>
                                    <td>{article.area}</td>
                                </tr>
                                <tr>
                                    <th>Operator(s):</th>
                                    <td>{article.operators && article.operators.length ? this.props.commaSeporate(article.operators) : 'N/A'}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    {/* <hr /> */}
                    {/* <Thumbnails article={article} /> */}
                    <hr />
                    <Share title={article.title} url={window.location.origin + window.location.pathname} />
                </Container>
            </div>
        )
    }
}

ArticleMobile.propTypes = {
    article: PropTypes.object.isRequired,
    authenticated: PropTypes.bool.isRequired,
    handleLogin: PropTypes.func.isRequired,
    user: PropTypes.object,
    link: PropTypes.object,
    sampleLink: PropTypes.object,
    commaSeporate: PropTypes.func.isRequired,
    commaSeporateComponents: PropTypes.func.isRequired
}

export default ArticleMobile